import { useCallback, useState } from "react";

export interface DocumentItem {
  id: string;
  file: File;
  description: string;
  note: string;
  uploadedAt: Date;
  isUploading?: boolean;
  uploadedResponse?: any;
  uploadError?: string;
}

export const useDocumentManagement = (initialDocuments: DocumentItem[] = []) => {
  const [documents, setDocuments] = useState<DocumentItem[]>(initialDocuments);

  const addDocuments = useCallback((newDocs: DocumentItem[]) => {
    setDocuments(prev => [...prev, ...newDocs]);
  }, []);

  const updateDocument = useCallback((id: string, updates: Partial<DocumentItem>) => {
    setDocuments(prev => prev.map(doc => (doc.id === id ? { ...doc, ...updates } : doc)));
  }, []);

  const updateDocumentNote = useCallback((id: string, note: string) => {
    updateDocument(id, { note });
  }, [updateDocument]);

  const deleteDocument = useCallback((id: string) => {
    setDocuments(prev => prev.filter(doc => doc.id !== id));
  }, []);

  const setAllDocuments = useCallback((docs: DocumentItem[]) => {
    setDocuments(docs);
  }, []);

  const getUploadedDocuments = useCallback(() => {
    return documents
      .filter(doc => doc.uploadedResponse)
      .map(doc => ({
        ...doc.uploadedResponse,
        note: doc.note
      }));
  }, [documents]);

  return {
    documents,
    addDocuments,
    updateDocument,
    updateDocumentNote,
    deleteDocument,
    setAllDocuments,
    getUploadedDocuments
  };
};
